import React from 'react';
import {Container, Row, Col} from 'react-bootstrap';
import BlogSection from 'components/common/sections/BlogSection';
import TryDemoSection from 'components/common/sections/TryDemoSection';
import {sidLinkedin, companyInstagram} from "../../utils/socialMedia";


const WhyInteractive = () => (
  <>
    {/* Blog header section */}
    <section id="blog-header-section" className="mb-2">
      <Container className="mt-5">
        <Row>
          <Col sm={12}>
            <h2>Why Interactive Brokers: A Smart Choice for Investors</h2>
            <p>
              Sid Goyal
              <span style={{color: "#00000099", marginLeft: "20px"}}>10 OCT 2023</span>
              <a href={sidLinkedin} target="_blank" rel="noopener noreferrer">
                <i className="bi bi-linkedin" style={{color: "#301E67", marginLeft: "20px"}}></i>
              </a>
              <a href={companyInstagram} target="_blank" rel="noopener noreferrer">
                <i className="bi bi-instagram" style={{color: "#301E67", marginLeft: "20px"}}></i>
              </a>
            </p>
          </Col>
        </Row>
      </Container>
    </section>
    {/* End */}

    {/* Blog Image Section */}
    <section id="blog-image-section" className="mb-3 mt-5 mt-lg-0">
      <Container fluid className="mt-2 px-0">
        <Row>
          <Col sm={12} className="text-center px-0 mb-2 mb-lg-4">
            <img className="img-fluid"
                 src="https://separate-backend-s3.s3.us-west-2.amazonaws.com/blog_img/Interactive-Brokers-Banner-with-White-Background-1024x195.png"
                 alt="Interactive Brokers Review"/>
          </Col>
        </Row>
      </Container>
    </section>
    {/* End */}

    {/* Blog Content section */}
    <section id="blog-content-section">
      <Container className="mt-3">
        <Row className="d-flex justify-content-center">
          <Col sm={12} lg={10} xl={8}
               className="d-flex align-items-center text-left mt-3 mt-lg-0 ps-2 ps-lg-5 bg-white">
            <div>
              <p style={{color: "#000000cc"}}>
                When it comes to investing, choosing the right brokerage platform is crucial. One name that consistently
                stands out in the world of online brokerage services is <strong>Interactive Brokers</strong>.
                <br/>
                If
                you're
                an investor looking for a reliable and feature-rich platform, here's why you should consider Interactive
                Brokers.
              </p>
              <div>
                <h2 style={{paddingTop: 10}}>1. Global Reach</h2>
              </div>
              <p style={{color: "#000000cc"}}>
                Interactive Brokers offers access to a wide range of global markets. Whether you're interested in
                stocks, options, futures, or forex trading, they provide access to markets across the world. This global
                reach allows you to diversify your portfolio and explore investment opportunities beyond your local
                market.
              </p>
              <div>
                <h2 style={{paddingTop: 10}}>2. Low Costs</h2>
              </div>
              <p style={{color: "#000000cc"}}>
                Investors appreciate Interactive Brokers for its competitive pricing. They offer some of the lowest
                trading commissions in the industry, making it cost-effective to buy and sell securities. Low fees mean
                you keep more of your investment gains, which can significantly impact your long-term returns.
              </p>
              <div>
                <h2 style={{paddingTop: 10}}>3. Powerful Trading Tools</h2>
              </div>
              <p style={{color: "#000000cc"}}>
                Interactive Brokers provides investors with a suite of powerful trading tools and research resources.
                Their platform is designed for both beginners and experienced traders, offering advanced charting,
                real-time market data, and customizable trading algorithms. These tools can help you make informed
                investment decisions.
              </p>
              <div>
                <h2 style={{paddingTop: 10}}>4. Strong Security</h2>
              </div>
              <p style={{color: "#000000cc"}}>
                Security is a top priority for Interactive Brokers. They use state-of-the-art technology and encryption
                protocols to safeguard your personal and financial information. With their commitment to security, you
                can trade with confidence knowing your assets are protected.
              </p>
              <div>
                <h2 style={{paddingTop: 10}}>5. Education and Support</h2>
              </div>
              <p style={{color: "#000000cc"}}>
                Whether you're new to investing or a seasoned pro, Interactive Brokers offers educational resources and
                excellent customer support. They provide webinars, tutorials, and a comprehensive knowledge base to help
                you improve your trading skills.
              </p>
              <div>
                <h2 style={{paddingTop: 10}}>6. Global Regulation and Proven Experience</h2>
              </div>
              <p style={{color: "#000000cc"}}>
                Interactive Brokers is not only a global brokerage but is also regulated in multiple countries. This
                means they adhere to stringent regulatory standards, ensuring a safe and transparent trading environment
                for their clients. Additionally, Interactive Brokers has been serving investors for a long time, having
                weathered various market conditions and economic cycles. Their experience in navigating different market
                scenarios adds to their credibility and reliability.
              </p>
              <p style={{color: "#000000cc", paddingTop: 10}}>
                In conclusion, Interactive Brokers is a smart choice for investors who value global access, low costs,
                powerful trading tools, security, and educational support. With their platform, you can take control of
                your investments and work towards your financial goals efficiently.
              </p>
              <p style={{color: "#000000cc", paddingTop: 10}}>
                Consider opening an account with Interactive Brokers today and experience the benefits of a brokerage
                that puts your financial success first.
              </p>
            </div>
          </Col>

        </Row>
      </Container>
    </section>
    {/* End */}

    {/* Blog section 2 */}
    <BlogSection/>

    {/* Try CTA section */}
    <TryDemoSection/>
  </>
);

export default WhyInteractive;